<template>
  <div class="page">
    <!-- 背景视频 -->
    <video class="video-background" autoplay muted loop>
      <source src="../../assets/bg1.mp4" type="video/mp4">
      <!-- <source src="../../assets/file_example_WEBM_1920_3_7MB.webm" type="video/webm">您的浏览器不支持视频标签。 -->
      您的浏览器不支持视频标签。
    </video>
    <!-- <div class="video-background"><img src="../../assets/video-to-gif-sample.gif"/></div> -->
    <div class="container">
      <div class="title titleXl" :class="isFlipped&&!isAnimating?'titleBottom':'titleTop'"></div>
      <div class="title titleWl" :class="isFlipped&&!isAnimating?'titleTop':'titleBottom'"></div>
      <div class="aibox" @click="aiClick('open')"></div>
      <div ref="threeContainer" class="model" v-loading="loading" element-loading-text="拼命加载中" element-loading-color="#fff" element-loading-background="rgba(0,0,0,0)"></div>
      <div class="action">
        <div class="action_box" v-if="actionShow">
          <!-- <div class="flx-bc line line1">
            <div class="item" @click="doModel('rotate','left')">左旋</div>
            <div class="item" @click="doModel('rotate','right')">右旋</div>
          </div>
          <div class="flx-bc line">
            <div class="item" @click="doModel('scale','big')">放大</div>
            <div class="item" @click="doModel('scale','small')">缩小</div>
          </div> -->
          <div class="line" @click="doAction('rotation')">翻转</div>
          <div class="line" @click="doModel('reset')">复位</div>
          <div class="line" @click="doAction('vr')">VR观看</div>
        </div>
        <div class="action_btn" @click="actionShow=!actionShow">操作按钮</div>
      </div>
      <ul class="flx-bc btnBox">
        <li class="btn" :class="scaqShow?'active':''" @click="scaqShow=true">生产安全</li>
        <li class="btn" :class="gylcShow?'active':''" @click="gylcShow=true">工艺流程</li>
        <li class="btn" :class="gwygShow?'active':''" @click="gwygShow=true">岗位员工</li>
        <li class="btn" :class="jqgShow?'active':''" @click="jqgShow=true">机器狗巡检</li>
        <li class="btn" :class="jslnShow?'active':''" @click="jslnShow=true">生成数字日志</li>
        <li class="btn" :class="jtjsShow?'active':''" @click="jtjsShow=true">集团介绍</li>
      </ul>
    </div>
    <!-- ai弹窗 -->
    <div class="maskbg_ai" v-if="aiShow"></div>
    <div class="aiDialog" v-if="aiShow" :style="aiType==='voice'?{width:'1240px',left:'1840px'}:''">
      <div class="tip" :style="aiType==='voice'?{left:'177px',top:'65px'}:''"><span v-if="errorMsg">{{errorMsg}}</span></div>
      <div class="loading" v-loading="connecting" :element-loading-text="loadingText" element-loading-color="#fff" element-loading-background="rgba(0,0,0,0.5)"></div>
      <div v-if="aiType==='text'" class="chat-container" id="chat-container">
          <div class="message" :class="item.type==='ai'?'left':'right'" v-for="(item,index) in message" :key="index">
              <div class="avatar">
                  <img :src="item.type==='ai'?'/assets/ai/photo_ai.png':'/assets/ai/photo_user.png'">
              </div>
              <div class="content">
                  <div class="bubble">{{item.content}}</div>
              </div>
          </div>
      </div>
      <div class="close" @click="aiClick('close')"></div>
      <!-- 主视频 -->
      <video class="video" v-show="!isSpeaking" ref="videoDefault" src="/assets/ai/ai.webm" autoplay muted loop></video>
      <!-- Speak 视频 -->
      <video class="video" v-show="isSpeaking" ref="videoSpeak" src="/assets/ai/ai_speak.webm" autoplay muted loop></video>
    </div>
    <!-- 音频播放 -->
    <audio ref="audioPlayer" @play="onPlayStart" @ended="onPlayEnd"></audio>
    <gylc v-if="gylcShow" :visible.sync="gylcShow" type="index" :list="jsonData.gylc"></gylc>
    <scaq v-if="scaqShow" :visible.sync="scaqShow"></scaq>
    <jqg v-if="jqgShow" :visible.sync="jqgShow" :videos="jsonData.jqg"></jqg>
    <jsln v-if="jslnShow" :visible.sync="jslnShow" :images="jsonData.jsln"></jsln>
    <vr v-if="vrShow" :visible.sync="vrShow" :src="jsonData.vrUrl"></vr>
    <gwyg v-if="gwygShow" :visible.sync="gwygShow" :info="jsonData.gwyg"></gwyg>
    <jtjs v-if="jtjsShow" :visible.sync="jtjsShow" :datas="jsonData.jtjs"></jtjs>
  </div>
</template>

<script>
// 引入 Three.js 核心
import * as THREE from 'three';
// 注意：从 three/examples/jsm/ 路径引入
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
// 如果需要轨道控制器
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
// 环境贴图
import { DebugEnvironment } from 'three/examples/jsm/environments/DebugEnvironment.js';
import TWEEN from 'three/examples/jsm/libs/tween.module.js';

import gylc from './gylc.vue'
import scaq from './scaq.vue'
import jqg from './jqg.vue'
import jsln from './jsln.vue'
import gwyg from './gwyg.vue'
import jtjs from './jtjs.vue'
import axios from 'axios'
import vr from './vr.vue'

import Recorder from 'recorder-core';
import 'recorder-core/src/engine/pcm.js'

export default {
  name: 'My3DComponent',
  components: { gylc,scaq,jqg,jsln,vr,gwyg,jtjs },
  data() {
    return {
      loading: true,
      scene: null,
      camera: null,
      renderer: null,
      controls: null,
      animationId: null,
      lastRender: 0, //模型渲染
      mixer: null,
      modelWl:null,
      modelXl:null,
      modelWl2: null, //上层物理模型
      modelXl2: null, //层虚拟模型
      scale: 1,
      rotationY: - Math.PI / 2,
      clickableObjects: [], //可点击的对象模型
      actionShow: false,
      aiShow: false,
      message: [],
      audioContext: null,
      index: '',
      stream: null,
      websocket: null,
      audioPlayer: null,
      isSpeaking: false,
      audioUrl: null,
      // audioChunks: [],
      // audioDuration: [],
      nextStartTime: 0,
      audioQueue: [], // 存放 { blob } 的队列
      reconnectTimer: null,     // 重连定时器
      reconnectAttempts: 0,     // 重连尝试次数
      maxReconnectAttempts: 5,  // 最大重连次数
      wsConnected: false,       // WebSocket连接状态
      isUserClosed: false,      // 是否是用户主动关闭

      scaqShow: false,
      gylcShow: false,
      gwygShow: false,
      jtjsShow: false,
      jqgShow: false,
      jslnShow: false,
      vrShow: false,
      modelGroup: null,
      isAnimating: false, // 防止翻转动画重叠
      isFlipped: false, //是否翻转过
      
      isRecording: false,
      startTime: '',
      connecting: false, //ai服务连接
      loadingText: '',
      errorMsg: '',
      aiType: 'text',

      jsonData: {jqg: [],gylc:[],jsln:[],}
    };
  },
  created(){
    this.getData('modelIndex')
  },
  async mounted() {
    // this.loading = false
    // 延迟 100ms 等待旧 context 回收
    setTimeout(() => {
      this.initThree();
      this.loadModel();
      this.animate();
      window.addEventListener('resize', this.onWindowResize);
    }, 100);
  },
  beforeDestroy() {
    // 清理 Three.js 资源，防止内存泄漏
    this.cleanUp();
    
    this.cleanupAi()
  },
  methods: {
    getData(name){
      let params = {fileName: name}
      axios.post(this.$baseUrl+'/api/web/file/data/query',params).then(res => {
        if(res.data.code === 200){
          this.jsonData = res.data.data
        }
      })
    },
    // 旋转，翻转模型
    doModel(type,value){
      // 原始大小
      const obj = {
        scale: 0.04,
        rotationY: - Math.PI / 2
      }
      if(type === 'scale'){
        if(value==='big'){
          this.scale += 0.1
        }else{
          this.scale -= 0.1
        }
        this.modelWl.scale.set(obj.scale*this.scale, obj.scale*this.scale, obj.scale*this.scale);
        this.modelXl.scale.set(obj.scale*this.scale, obj.scale*this.scale, obj.scale*this.scale);
        this.modelWl2.scale.set(obj.scale*this.scale, obj.scale*this.scale, obj.scale*this.scale);
        this.modelXl2.scale.set(obj.scale*this.scale, obj.scale*this.scale, obj.scale*this.scale);
      }else if(type === 'rotate'){
        if(value==='left'){
          this.rotationY -= Math.PI / 2
          this.modelWl.rotation.y = this.rotationY;
          this.modelXl.rotation.y = this.rotationY;
          this.modelWl2.rotation.y = this.rotationY;
          this.modelXl2.rotation.y = this.rotationY;
        }else{
          this.rotationY += Math.PI / 2
          this.modelWl.rotation.y = this.rotationY;
          this.modelXl.rotation.y = this.rotationY;
          this.modelWl2.rotation.y = this.rotationY;
          this.modelXl2.rotation.y = this.rotationY;
        }
      }else if(type === 'reset'){
        this.modelWl.rotation.y = obj.rotationY;
        this.modelXl.rotation.y = obj.rotationY;
        this.modelWl.scale.set(obj.scale, obj.scale, obj.scale);
        this.modelXl.scale.set(obj.scale, obj.scale, obj.scale);
        this.modelWl2.rotation.y = obj.rotationY;
        this.modelXl2.rotation.y = obj.rotationY;
        this.modelWl2.scale.set(obj.scale, obj.scale, obj.scale);
        this.modelXl2.scale.set(obj.scale, obj.scale, obj.scale);
        this.controls.reset();
        this.performFlipAnimation('reset')
      }
    },
    // 其他操作
    doAction(type){
      if(type==='vr'){
        this.vrShow = true
      }else if(type==='rotation'){
        this.performFlipAnimation()
      }
    },
    // 翻转动画函数
    performFlipAnimation(reset) {
      if (this.isAnimating) return; // 如果动画正在进行，忽略新请求
      this.isAnimating = true;
      let targetRotationX;
      if (reset) {
        targetRotationX = 0;
        this.isFlipped = false;
      } else {
          // 基于是否已翻转决定是 +π 还是 -π，避免重复翻转出错
          targetRotationX = this.isFlipped ? 0 : Math.PI;
          this.isFlipped = !this.isFlipped;
      }
      let that = this
      new TWEEN.Tween({ rotation: that.modelGroup.rotation.x })
          .to({ rotation: targetRotationX }, 1000) // 1秒完成动画
          .easing(TWEEN.Easing.Cubic.InOut)
          .onUpdate(function(obj) {
              that.modelGroup.rotation.x = obj.rotation;
          })
          .onComplete(function() {
              that.isAnimating = false; // 动画完成，允许下一次点击
              console.log(targetRotationX)
          })
          .start();
          if(targetRotationX===0){
            that.modelWl.rotation.x = -0.2
            that.modelWl2.rotation.x = -0.2
            that.modelXl.rotation.x = 0.2
            that.modelXl2.rotation.x = 0.2
            that.modelWl.position.y = -4.4
            that.modelWl2.position.y = -4.4
            that.modelXl.position.y = 5.1
            that.modelXl2.position.y = 5.1
          }else{
            that.modelWl.rotation.x = 0
            that.modelWl2.rotation.x = 0
            that.modelXl.rotation.x = -0.2
            that.modelXl2.rotation.x = -0.2
            that.modelWl.position.y = -4.3
            that.modelWl2.position.y = -4.3
            that.modelXl.position.y = 4.45
            that.modelXl2.position.y = 4.45
          }
    },
    initThree() {
      // 创建场景
      this.scene = new THREE.Scene();
      this.scene.background = null; // 设置场景背景透明

      // 创建相机
      const width = this.$refs.threeContainer.offsetWidth;
      const height = this.$refs.threeContainer.offsetHeight;
      this.camera = new THREE.PerspectiveCamera(75, width / height, 0.1, 1000);
      this.scene.add(this.camera);//将相机加入到场景中
      this.camera.position.z = 10;

      // 创建渲染器
      this.renderer = new THREE.WebGLRenderer({ antialias: true,alpha: true });
      this.renderer.setSize(width, height);
      this.renderer.setPixelRatio(window.devicePixelRatio);
      this.renderer.outputEncoding = THREE.sRGBEncoding;
      this.renderer.toneMapping = THREE.ACESFilmicToneMapping;
      this.renderer.toneMappingExposure = 1.5; // 调整此值来改变亮度
      this.renderer.setClearAlpha(0); // 设置背景透明度为0
      
      this.renderer.shadowMap.enabled = true;
      this.renderer.shadowMap.type = THREE.PCFSoftShadowMap; // 更柔和的阴影效果

      this.$refs.threeContainer.appendChild(this.renderer.domElement);
      // ✅ 关键：绑定 click 到 renderer.domElement（即 canvas）
      this.renderer.domElement.addEventListener('click', this.onClick);
      
      // 使用 DebugEnvironment
      const environment = new DebugEnvironment();
      const pmremGenerator = new THREE.PMREMGenerator(this.renderer);
      this.scene.environment = pmremGenerator.fromScene(environment).texture;

      // // 添加轨道控制器（可选）
      this.controls = new OrbitControls(this.camera, this.renderer.domElement);
      //是否可以缩放
      this.controls.enableZoom = true;
      //是否自动旋转
      this.controls.autoRotate = false;
      //设置相机距离原点的最远距离
      this.controls.minDistance = 1;
      //设置相机距离原点的最远距离
      this.controls.maxDistance = 10;
      //是否开启右键拖拽
      this.controls.enablePan = true;// 在 initThree() 或 setupControls() 中添加

      // 添加环境光
      const ambientLight = new THREE.AmbientLight(0xffffff, .5);
      this.scene.add(ambientLight);
      // 添加平行光
      // const directionalLight = new THREE.DirectionalLight(0xffffff, .8);
      // directionalLight.position.set(1,1,1);
      // this.scene.add(directionalLight);
      const sunLight = new THREE.DirectionalLight(0xffffff, 5);
      sunLight.position.set(10, 10, -2);
      sunLight.castShadow = true;
      sunLight.shadow.mapSize.width = 2048;
      sunLight.shadow.mapSize.height = 2048;
      sunLight.shadow.camera.left = -15;
      sunLight.shadow.camera.right = 15;
      sunLight.shadow.camera.top = 15;
      sunLight.shadow.camera.bottom = -15;
      sunLight.shadow.camera.near = 0.5;
      sunLight.shadow.camera.far = 30;
      this.scene.add(sunLight);
      
      this.modelGroup = new THREE.Group();
      this.scene.add(this.modelGroup);
    },
    loadModel() {
      let that = this
      const gltfLoader = new GLTFLoader();
      // 包装加载为 Promise，并支持进度反馈
      function loadModel(url, position, rotation) {
        return new Promise((resolve, reject) => {
          gltfLoader.load(
            url,
            (gltf) => {
              const model = gltf.scene;
              model.position.set(...position);
              model.scale.set(0.04, 0.04, 0.04);
              model.rotation.y = - Math.PI / 2;
              model.rotation.x = rotation
              // 自定义数据：跳转链接
              let type = url.indexOf('物理')>-1 ? 'wl1' : url.indexOf('虚拟')>-1 ? 'xl1' : url.indexOf('wuli')>-1 ? 'wl' : 'xl'
              console.log(type)
              if(type==='wl1'){
                model.traverse((child) => {
                    if (child.isMesh) {
                      // child.castShadow = true;
                      // child.receiveShadow = true;
                    }
                });
                that.modelWl = model
              }else if(type==='xl1'){
                model.traverse((child) => {
                  if (child.isMesh) {
                    // 反白原因:材质反光太强	降低 roughness / metalness
                    child.material.roughness = 0.7;  // 增加粗糙度，减少反光
                    child.material.metalness = 0.3;  // 减少金属感模型是0.5
                    child.material.envMapIntensity = 0.6; //降低环境反射模型是1
                  }
                });
                that.modelXl = model
              }else if(type==='wl'){
                model.traverse((child) => {
                    if (child.isMesh) {
                      child.material.visible = false; // 完全不可见
                      child.userData = { url: '/subpage?type='+type };
                      that.clickableObjects.push(child);
                    }
                });
                that.modelWl2 = model
              }else{
                model.traverse((child) => {
                    if (child.isMesh) {
                      child.material.visible = false; // 完全不可见
                      child.userData = { url: '/subpage?type='+type };
                      that.clickableObjects.push(child);
                    }
                });
                that.modelXl2 = model
              }
              that.scene.add(model);
              
              that.modelGroup.add(model);

              resolve(gltf); // 加载成功
            },
            (progress) => {
              // console.log(url+'加载进度:', (progress.loaded / progress.total * 100) + '% loaded');
            },
            (error) => reject(error) // 加载失败
          );
        });
      }
      // 所有加载任务
      const loadPromises = [
        loadModel(
          '/assets/3d/物理工厂.glb',
          [0, -4.4, 0],  // 位置：底部0,-5,0
          -0.2 // 轻微抬头（0.3约17度）
        ),
        loadModel(
          '/assets/3d/wuligongchaangzhengti_button.glb',
          [0, -4.4, 0],  // 位置：底部0,-5,0
          -0.2 // 轻微抬头（0.3约17度）
        ),
        loadModel(
          '/assets/3d/虚拟工厂上.glb',
          [0, 5.1, 0],   // 位置：顶部0,5,0
          0.2 // 轻微抬头（0.3约17度）
        ),
        loadModel(
          '/assets/3d/xunigongchangzhengti_button.glb',
          [0, 5.1, 0],   // 位置：顶部0,5,0
          0.2 // 轻微抬头（0.3约17度）
        )
      ];
      // 所有模型同时加载，等全部完成
      let loadedCount = 0;
      const totalModels = loadPromises.length;
      // 监听每个模型完成
      loadPromises.forEach(promise => {
        promise.then((gltf) => {
          loadedCount++;
          if (loadedCount === totalModels) {
            // 所有模型加载完成
            this.loading = false
            console.log('✅ All models loaded and ready!');
            // 获取动画混合器
            // const animations = gltf.animations;
            // if (animations && animations.length) {
            //   this.mixer = new THREE.AnimationMixer(model);
            //   for (let i = 0; i < animations.length; i++) {
            //     const action = this.mixer.clipAction(animations[i]);
            //     action.play();
            //   }
            // }
          }
        }).catch(err => {
          console.error('❌ Model load error:', err);
        });
      });
    },
    // 不需要每帧都渲染（尤其是静态场景）：
    animate(time) {
      this.animationId = requestAnimationFrame(this.animate);
      // 限制渲染频率
      const TARGET_FPS = 30;
      if (time - this.lastRender < 1000 / TARGET_FPS) return;
      this.lastRender = time;

      // 更新动画
      if (this.mixer) {
        this.mixer.update(0.05);
      }
      // 更新控制器
      if (this.controls) {
        this.controls.update();
      }
      // 渲染场景
      this.renderer.render(this.scene, this.camera);

      TWEEN.update(); // 更新所有活动的Tween动画
    },
    onClick(event) {
      const rect = this.renderer.domElement;
      const mouse = new THREE.Vector2(
        (event.offsetX / rect.clientWidth) * 2 - 1,
        -(event.offsetY / rect.clientHeight) * 2 + 1
      );
      // 设置射线
      const raycaster = new THREE.Raycaster()
      raycaster.setFromCamera(mouse, this.camera);
      raycaster.firstHitOnly = true;
      // 检测相交
      const intersects = raycaster.intersectObjects(this.clickableObjects);
      if (intersects.length > 0) {
        const target = intersects[0].object; // 代理对象
        console.log(target)
        if (target.userData && target.userData.url) {
          this.cleanUp();
          const url = target.userData.url;
          if (url.startsWith('http')) {
            window.open(url, '_blank');
          } else {
            this.$router.push(url).catch(err => {
              if (err.name !== 'NavigationDuplicated') throw err;
            });
          }
        }
      }
    },
    onWindowResize() {
      const container = this.$refs.threeContainer;
      this.camera.aspect = container.clientWidth / container.clientHeight;
      this.camera.updateProjectionMatrix();
      this.renderer.setSize(container.clientWidth, container.clientHeight);
    },
    cleanUp() {
      console.log("清理 Three.js 资源，防止内存泄漏")
      // 清理资源
      window.removeEventListener('resize', this.onWindowResize);
      if (this.animationId) {
        cancelAnimationFrame(this.animationId);
        this.animationId = null;
      }
      if (this.controls) {
        this.controls.dispose();
        this.controls = null;
      }
      if (this.composer) {
        this.composer.renderTarget1.dispose();
        this.composer.renderTarget2.dispose();
        this.composer = null;
      }
      if (this.outlinePass) {
        if (this.outlinePass.renderTarget1) this.outlinePass.renderTarget1.dispose();
        if (this.outlinePass.renderTarget2) this.outlinePass.renderTarget2.dispose();
        this.outlinePass = null;
      }
      if(this.modelWl){
        this.disposeModel(this.modelWl)
        this.modelWl = null
      }
      if(this.modelWl){
        this.disposeModel(this.modelWl2)
        this.modelWl2 = null
      }
      if(this.modelXl){
        this.disposeModel(this.modelXl)
        this.modelXl = null
      }
      if(this.modelXl2){
        this.disposeModel(this.modelXl2)
        this.modelXl2 = null
      }
      if (this.scene) {
        this.scene.clear();
        this.scene = null;
      }
      this.camera = null;
      if (this.renderer) {
        this.renderer.dispose();
        this.renderer.forceContextLoss();
        const canvas = this.renderer.domElement;
        if (canvas && canvas.parentNode) {
          canvas.parentNode.removeChild(canvas);
        }
        this.renderer = null;
      }
    },
    // 切换模型时销毁的 THREE.Mesh 或其父级 Group
    disposeModel(model) {
      // 遍历模型中的所有子对象
      model.traverse((child) => {
          if (child.isMesh) { // 如果是网格
              // 1. 释放几何体
              if (child.geometry) {
                  child.geometry.dispose();
              }
              // 2. 释放 material 和 textures
              if (child.material) {
                const materials = Array.isArray(child.material) ? child.material : [child.material];
                materials.forEach(mat => {
                  // 手动释放所有纹理
                  ['map', 'normalMap', 'emissiveMap', 'roughnessMap'].forEach(key => {
                    if (mat[key] && mat[key].isTexture) {
                      mat[key].dispose();
                    }
                  });
                  mat.dispose(); // 最后释放材质
                });
              }
          }
      });
      // 3. 从场景中移除该模型
      this.scene.remove(model);
    },
    async aiClick(type){
      if(type === 'open'){
        this.isUserClosed = false; // 用户打开时重置标志位
        this.aiShow = true
        this.connecting = true
        this.loadingText = '服务连接中'
        this.message = []
        this.isRecording = false
        this.startTime = ''
        this.errorMsg = ''
        this.aiType = 'text'
        await this.initAudioContext();
        this.initWebSocket()
      }else{
        this.isUserClosed = true; // 用户主动关闭时设置标志位
        this.aiShow = false
        this.connecting = false
        this.loadingText = ''
        this.aiType = 'text'
        this.cleanupAi()
      }
    },
    // 初始化 Web Audio API
    async initAudioContext() {
      try {
        if (!this.audioContext) {
          this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
        }
        if (this.audioContext.state === 'suspended') {
          await this.audioContext.resume();
        }
        this.nextStartTime = this.audioContext.currentTime;
        this.audioPlayer = this.$refs.audioPlayer;
        console.log('音频播放准备就绪')
      } catch (e) {
        console.error('AudioContext 初始化失败:', e);
        this.errorMsg = '浏览器不支持Web音频'
      }
    },
    initWebSocket() {
      // 示例：火山引擎实时语音识别 WebSocket 地址（需替换 token/appid 等）
      const url = `${this.$wsUrl}/wss/audio?userId=亚克卓玛`
      this.websocket = new WebSocket(url);
      this.websocket.onopen = () => {
        console.log('WebSocket 已连接');
        this.connecting = false;
        this.loadingText = '';
        this.wsConnected = true;
        this.reconnectAttempts = 0;
        clearTimeout(this.reconnectTimer);
        if(this.message.length===0){
          // 播放欢迎词
          this.textToVoice();
        }
      };

      this.websocket.onmessage = (event) => {
        console.log("接收消息");
        let res = JSON.parse(event.data);
        console.log(res);
        if(res.code === 200){
          if(res.type === 'text_search'){
            this.connecting = false;
            this.loadingText = '';
            this.errorMsg = ''
            this.aiType = 'text'
            // 添加h5文字搜索的问题和回答状态
            this.message.push({
              content: res.question,
              type: 'user',
              index: res.index
            });
            this.message.push({
              content: '努力思考中...',
              type: 'ai',
              index: res.index
            });
            this.scrollToBottom();
          }else if(res.type === 'voice'){
            // 文本大模型结果返回
            const base64String = res.data;
            const audioData = atob(base64String); // 将Base64解码为二进制字符串
            const byteArray = new Uint8Array(audioData.length);
            for (let i = 0; i < audioData.length; i++) {
                byteArray[i] = audioData.charCodeAt(i);
            }
            const blob = new Blob([byteArray], {type: 'audio/mp3'}); 
            this.audioUrl = URL.createObjectURL(blob);
            // 设置到 audio 元素并播放
            this.audioPlayer.src = this.audioUrl;
            this.audioPlayer.play();
            //1-音频，2-文本
            if(res.flag===2){
              let obj = this.message.find(it => it.index === res.index && it.type==='ai');
              if(obj){
                this.$set(obj,'content',res.answer);
              }else{
                this.message.push({
                  content: res.answer,
                  type: 'ai',
                  index: res.index
                });
              }
              this.scrollToBottom();
            }
          }else if(res.type === 'connect'){
            this.aiType = 'voice';
          }else if(res.type === 'damoxin'){
            // 语音流大模型结果返回
            if (res.flag == 1) {
              this.onVoiceMessage(res)
            }
          }
        }else if(res.code === 600){
            // 语音对话结束
            this.errorMsg = '语音对话已结束'
            this.connecting = false
        }else{
          this.errorMsg = res.msg;
        }
      };

      this.websocket.onerror = (err) => {
        console.error('WebSocket 错误:', err);
        this.handleWsError();
      };
      
      this.websocket.onclose = (event) => {
        console.log('WebSocket 已关闭:', event.code, event.reason);
        this.wsConnected = false;
        this.errorMsg = '服务已关闭，正在重连...';
        this.handleWsClose();
      };
    },
    
    // WebSocket错误处理
    handleWsError() {
      console.error('WebSocket 连接错误');
      this.handleWsClose();
    },
    
    // WebSocket关闭处理
    handleWsClose() {
      // 清理现有连接
      if (this.websocket) {
        this.websocket.onopen = null;
        this.websocket.onmessage = null;
        this.websocket.onerror = null;
        this.websocket.onclose = null;
        this.websocket.close();
        this.websocket = null;
      }
      
      // 如果是用户主动关闭，不再尝试重连
      if (this.isUserClosed) {
        console.log('用户主动关闭，不进行重连');
        return;
      }
      
      // 尝试重连
      if (this.reconnectAttempts < this.maxReconnectAttempts) {
        this.reconnectAttempts++;
        const delay = Math.min(1000 * Math.pow(2, this.reconnectAttempts), 5000); // 指数退避
        console.log(`WebSocket 重连尝试 ${this.reconnectAttempts}/${this.maxReconnectAttempts}，延迟 ${delay}ms`);
        this.reconnectTimer = setTimeout(() => {
          this.initWebSocket();
        }, delay);
      } else {
        this.errorMsg = '服务重连失败，请关闭对话后重试';
        this.connecting = false;
      }
    },
    // 文字转语音
    textToVoice(){
      console.log("发送文字转语音")
      let data = {
        type: 'voice',
        userId: '亚克卓玛',
        data: '欢迎来到牦牛酪蛋白数智孪生工厂'
      }
      this.websocket.send(JSON.stringify(data))
    },
    onPlayStart() {
      this.isSpeaking = true
      console.log('音频播放开始');
      this.$nextTick(() => {
        const video = this.$refs.videoSpeak;
        if (video) {
          video.play().catch(e => console.log('自动播放失败:', e));
        }
      });
    },
    onPlayEnd() {
      this.isSpeaking = false
      console.log('音频播放结束');
      this.$nextTick(() => {
        const video = this.$refs.videoDefault;
        if (video) {
          video.play().catch(e => console.log('自动播放失败:', e));
        }
      });
      // 可选：释放 Blob URL
      if (this.audioUrl) {
        URL.revokeObjectURL(this.audioUrl);
        this.audioUrl = null;
      }
    },
    /**
     * desc: base64对象转blob文件对象
     * @param base64  ：数据的base64对象
     * @param fileType  ：文件类型 mp3等;
     * @returns {Blob}：Blob文件对象
     */
    // 接收 WebSocket 消息
    async onVoiceMessage(res) {
      const blob = this.base64ToBlob(res.data, 'wav'); // ✅ 生成 Blob
      const arrayBuffer = await blob.arrayBuffer();
      // 关键：检查是否真的是 ArrayBuffer
      if (!(arrayBuffer instanceof ArrayBuffer)) {
        console.error('Not an ArrayBuffer!', typeof arrayBuffer);
        return;
      }
      const audioBuffer = await this.audioContext.decodeAudioData(arrayBuffer);
      if (!audioBuffer) return;
      this.audioQueue.push(audioBuffer);
      if (!this.isSpeaking) {
        this.isSpeaking = true;
        this.nextStartTime = this.audioContext.currentTime;
        this.playNextFromQueue();
      }
    },
    base64ToBlob(base64, fileType = 'wav') {
      // ✅ 正确设置 MIME 类型
      const mimeType = fileType === 'mp3' ? 'audio/mpeg' : 'audio/wav';
      // ✅ 解码 Base64 字符串为二进制
      const byteString = atob(base64); // 注意：base64 必须是纯字符串，无头
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      // ✅ 返回正确类型的 Blob
      return new Blob([ab], { type: mimeType });
    },
     // 无缝播放队列 ===
    playNextFromQueue() {
      if (this.audioQueue.length === 0 || !this.audioContext) {
        this.isSpeaking = false;
        this.onPlayEnd();
        return;
      }

      const audioBuffer = this.audioQueue.shift();
      const source = this.audioContext.createBufferSource();
      source.buffer = audioBuffer;
      source.connect(this.audioContext.destination);

      source.start(this.nextStartTime);
      this.nextStartTime += audioBuffer.duration;

      source.onended = () => {
        this.playNextFromQueue(); // 自动播下一段
      };
    },
    cleanupAi() {
      // 清理AI资源时，确保不再重连
      this.isUserClosed = true;
      
      // 先清理重连定时器，确保不会有延迟的重连尝试
      if (this.reconnectTimer) {
        clearTimeout(this.reconnectTimer);
        this.reconnectTimer = null;
      }
      
      // 关闭WebSocket前先移除事件监听器，避免触发onclose事件导致重复清理
      if (this.websocket) {
        this.websocket.onopen = null;
        this.websocket.onmessage = null;
        this.websocket.onerror = null;
        this.websocket.onclose = null;
        this.websocket.close();
        this.websocket = null;
      }
      
      // 清理其他资源
      if (this.stream) {
        this.stream.getTracks().forEach(t => t.stop());
        this.stream = null;
      }
      if (this.audioContext) {
        this.audioContext.close();
        this.audioContext = null;
      }
      if (this.audioUrl) {
        this.audioPlayer.pause();
        URL.revokeObjectURL(this.audioUrl);
        this.audioUrl = null;
      }
      if (this.rec) {
        this.rec.close();
        this.rec = null;
      }
      
      // 清理数据
      this.audioChunks = [];
      this.audioDuration = [];
      this.res = null;
      this.silentCount = 0;
      this.startTime = '';
      this.isRecording = false;
      this.reconnectAttempts = 0;
      this.wsConnected = false;
    },
    scrollToBottom() {
        this.$nextTick(() => {
          const container = document.getElementById('chat-container');
          container.scrollTop = container.scrollHeight;
        })
    },
  }
};
</script>

<style lang="less" scoped>
@import '@/styles/index';
@import '@/styles/ai';
</style>